import { MapPinned, Compass } from "lucide-react";
import { Reveal, SectionLabel } from "../../lib/motion";
import { COMMUNITY_LOCATION_DESC, COMMUNITY_LOCATION_MAP } from "../../data";

export const CommunityLocation = () => {
  return (
    <section id="location" className="py-24 md:py-32 bg-white scroll-mt-20">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          <Reveal>
            <SectionLabel>Community Location</SectionLabel>
            <h2 className="font-serif text-4xl md:text-5xl font-light text-navy mt-4 leading-tight">
              Virginia’s Northern Neck
            </h2>
            <p className="mt-6 text-warm leading-relaxed text-lg">{COMMUNITY_LOCATION_DESC}</p>

            <div className="mt-8 flex flex-wrap gap-3">
              {["Chesapeake Bay access", "Near Heathsville", "Grocery ~10 min", "Hardware ~15 min"].map((t) => (
                <span key={t} className="inline-flex items-center gap-2 bg-forest-pale text-forest rounded-full px-4 py-2 text-sm font-medium">
                  <Compass size={14} /> {t}
                </span>
              ))}
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <div
              data-testid="community-location-map"
              className="relative rounded-3xl overflow-hidden border border-warm-border shadow-[0_24px_70px_-28px_rgba(11,37,69,0.3)]"
            >
              {COMMUNITY_LOCATION_MAP ? (
                <img
                  src={COMMUNITY_LOCATION_MAP}
                  alt="Bay Quarter Shores location within Northumberland County, Virginia"
                  loading="lazy"
                  className="w-full h-[460px] object-cover"
                />
              ) : (
                <div className="relative h-[460px] bg-gradient-to-br from-water-pale to-forest-pale flex flex-col items-center justify-center text-center px-8">
                  <div className="map-grid absolute inset-0" />
                  <div className="absolute bottom-0 left-0 right-0 h-2/5 bg-water/12 rounded-t-[45%] blur-[1px]" />
                  <div className="relative z-10 w-14 h-14 rounded-full bg-white shadow-lg flex items-center justify-center">
                    <MapPinned size={26} className="text-water" />
                  </div>
                  <p className="relative z-10 mt-4 font-serif text-2xl text-navy">Bay Quarter Shores</p>
                  <p className="relative z-10 text-sm text-warm mt-1">Northumberland County, Virginia</p>
                  <p className="relative z-10 text-xs text-warm/70 mt-4 max-w-xs">
                    Community location map to be added.
                  </p>
                </div>
              )}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
